// Breeze Partnerships — scroll & interactions
if (!window.__breezePartnershipsLoaded) {
window.__breezePartnershipsLoaded = true;
(function () {
  // Duplicate marquee for seamless loop
  const track = document.getElementById('marquee-track');
  if (track) {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  }

  // Sticky nav state
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 20) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        // Animate counters when section enters
        e.target.querySelectorAll('[data-count]').forEach(animateCounter);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  function animateCounter(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    const target = parseFloat(el.dataset.count);
    const suffix = el.dataset.suffix || '';
    const dur = 1400;
    const start = performance.now();
    const isFloat = target % 1 !== 0;
    function tick(now) {
      const t = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - t, 3);
      const v = target * eased;
      el.textContent = (isFloat ? v.toFixed(1) : Math.round(v).toLocaleString()) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // Email copy
  const btn = document.querySelector('.email-pill .copy');
  if (btn) {
    btn.addEventListener('click', () => {
      const email = btn.dataset.email;
      navigator.clipboard?.writeText(email).then(() => {
        const orig = btn.textContent;
        btn.textContent = 'Copied ✓';
        btn.classList.add('copied');
        setTimeout(() => {
          btn.textContent = orig;
          btn.classList.remove('copied');
        }, 1800);
      });
    });
  }

  // Subtle parallax on hero art
  const heroArt = document.querySelector('.hero-art img');
  if (heroArt && window.matchMedia('(min-width: 960px)').matches) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      heroArt.style.transform = `translateY(${y * -0.06}px)`;
    }, { passive: true });
  }

  // Browser tilt - bind once
  document.querySelectorAll('.module').forEach((mod) => {
    const c = mod.querySelector('.container');
    if (c && c.classList.contains('flip')) mod.classList.add('flipped');
  });

  // Partnership testimonials carousel
  document.querySelectorAll('.testimonials-stage').forEach((stage) => {
    const track = stage.querySelector('.testimonials-track');
    const slides = Array.from(stage.querySelectorAll('.testimonial-slide'));
    const dots = Array.from(stage.querySelectorAll('.ts-dot'));
    const prevBtn = stage.querySelector('.ts-prev');
    const nextBtn = stage.querySelector('.ts-next');

    if (!slides.length || !track) return;

    let current = 0;
    let timer = null;
    const delay = (parseInt(stage.dataset.autoplay, 10) || 5) * 1000;

    function setTrackHeight() {
      let max = 0;
      slides.forEach((s) => { if (s.scrollHeight > max) max = s.scrollHeight; });
      track.style.minHeight = max + 'px';
    }

    function goTo(idx) {
      slides[current].classList.remove('active');
      if (dots[current]) {
        dots[current].classList.remove('active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) {
        dots[current].classList.add('active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function startTimer() {
      clearInterval(timer);
      if (slides.length > 1) timer = setInterval(() => goTo(current + 1), delay);
    }

    // Ensure first slide is active and track has a stable height
    slides.forEach((s, i) => s.classList.toggle('active', i === 0));
    if (dots[0]) { dots[0].classList.add('active'); dots[0].setAttribute('aria-selected', 'true'); }
    setTrackHeight();
    startTimer();

    window.addEventListener('resize', setTrackHeight);

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); startTimer(); });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); startTimer(); });
    });
  });
})();
}
